/* Dragons Peak — Alien World.
   1) The crossing: a portal in the dragon world, a hyperspace tunnel scrubbed by scroll, a flash, arrival.
   2) The far side: three.js flying saucers, a cartoon flyby, and GSAP comic hype (after Ralph & the Unknown).
   3) Sound: a riser and a boom, only after the visitor presses "Open the portal". */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const root = document.documentElement, REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
const warp = $('#awWarp'), pin = warp && $('.aw-pin', warp), tunnel = $('#awTunnel');
if (!warp) return;

/* the header's book button would jump to the dragon shop: point it at this page's offer instead */
const cta = $('[data-aw]').dataset.cta;
$$('.site-header [data-scroll-buy], #MenuDrawer [data-scroll-buy]').forEach(a => { a.setAttribute('href', '#aw-offer'); if (cta) a.textContent = cta; });
const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
const sstep = (a, b, x) => { const t = clamp((x - a) / (b - a)); return t * t * (3 - 2 * t); };
const lerp = (a, b, t) => a + (b - a) * t;

/* =====================================================================
   SOUND: synthesised, no files
   ===================================================================== */
const S = (() => {
  let ctx = null, master = null, nb = null;
  function start() {
    if (ctx) { ctx.resume(); return; }
    const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    ctx = new AC(); master = ctx.createGain(); master.gain.value = .8;
    const comp = ctx.createDynamicsCompressor(); master.connect(comp); comp.connect(ctx.destination);
    nb = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate); const d = nb.getChannelData(0); for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
  }
  const env = (g, t, pts) => { g.gain.setValueAtTime(pts[0][1], t); for (let i = 1; i < pts.length; i++) g.gain.exponentialRampToValueAtTime(Math.max(pts[i][1], .0001), t + pts[i][0]); };
  function riser(dur) {
    if (!ctx) return; const t = ctx.currentTime;
    const n = ctx.createBufferSource(); n.buffer = nb; n.loop = true; const f = ctx.createBiquadFilter(), g = ctx.createGain();
    f.type = 'bandpass'; f.Q.value = 1.6; f.frequency.setValueAtTime(160, t); f.frequency.exponentialRampToValueAtTime(6000, t + dur);
    env(g, t, [[0, .001], [dur, .55], [dur + .05, .0001]]); n.connect(f); f.connect(g); g.connect(master); n.start(t); n.stop(t + dur + .1);
    /* a theremin-style wobble climbing into the unknown */
    const o = ctx.createOscillator(), og = ctx.createGain(), lfo = ctx.createOscillator(), lg = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(220, t); o.frequency.exponentialRampToValueAtTime(1320, t + dur);
    lfo.frequency.value = 7; lg.gain.value = 18; lfo.connect(lg); lg.connect(o.frequency);
    env(og, t, [[0, .001], [dur * .3, .12], [dur, .18], [dur + .05, .0001]]); o.connect(og); og.connect(master);
    o.start(t); lfo.start(t); o.stop(t + dur + .1); lfo.stop(t + dur + .1);
  }
  function boom() {
    if (!ctx) return; const t = ctx.currentTime;
    const o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(30, t + .9);
    env(g, t, [[0, 1], [2.2, .0001]]); o.connect(g); g.connect(master); o.start(t); o.stop(t + 2.3);
    /* the arrival chime: a bright major chord */
    [523.25, 659.25, 783.99, 1046.5].forEach((fq, i) => { const c = ctx.createOscillator(), cg = ctx.createGain(); c.type = 'triangle'; c.frequency.value = fq;
      env(cg, t + i * .05, [[0, .001], [.05, .12], [1.6, .0001]]); c.connect(cg); cg.connect(master); c.start(t + i * .05); c.stop(t + 1.8); });
  }
  return { start, riser, boom, get on() { return !!ctx; } };
})();

/* =====================================================================
   THE CROSSING: hyperspace tunnel on a 2D canvas, scrubbed by scroll
   ===================================================================== */
const cx = tunnel.getContext('2d');
const SMALL = Math.min(innerWidth, innerHeight) < 700, N = SMALL ? 420 : 900;
const NEON = [[166, 255, 31], [255, 43, 214], [63, 231, 255], [255, 224, 31], [255, 255, 255]];
const stars = Array.from({ length: N }, () => ({ x: (Math.random() * 2 - 1) * 1.4, y: (Math.random() * 2 - 1) * 1.4, z: Math.random(), pz: 0, c: NEON[(Math.random() * NEON.length) | 0], e: Math.random() }));
let W = 0, H = 0, DPR = 1;
function size() { DPR = Math.min(devicePixelRatio || 1, SMALL ? 1.5 : 2); W = tunnel.clientWidth; H = tunnel.clientHeight; tunnel.width = W * DPR; tunnel.height = H * DPR; cx.setTransform(DPR, 0, 0, DPR, 0, 0); }
size(); addEventListener('resize', size);

let p = 0, shown = -1, arrived = false, last = performance.now();
function progress() { const r = warp.getBoundingClientRect(), span = r.height - innerHeight; return span > 0 ? clamp(-r.top / span) : 1; }
function drawTunnel(dt) {
  const mix = sstep(.3, .62, p), speed = .02 + Math.pow(p, 2.2) * 2.6, f = Math.min(W, H) * .55;
  /* the sky behind: ember night in the dragon world, deep violet on the far side; low alpha leaves light trails */
  const bg = [lerp(4, 27, mix), lerp(10, 6, mix), lerp(7, 71, mix)];
  cx.fillStyle = `rgba(${bg[0] | 0},${bg[1] | 0},${bg[2] | 0},${lerp(.9, .32, sstep(.05, .5, p))})`; cx.fillRect(0, 0, W, H);
  const ox = W / 2, oy = H / 2;
  cx.lineCap = 'round';
  for (const s of stars) {
    s.pz = s.z; s.z -= speed * dt;
    if (p < .25) { s.y -= (.05 + s.e * .08) * dt * (1 - p * 4); }   /* embers rise before the warp takes hold */
    if (s.z <= .02) { s.z = 1; s.pz = 1; s.x = (Math.random() * 2 - 1) * 1.4; s.y = (Math.random() * 2 - 1) * 1.4; }
    if (s.y < -1.6) s.y += 3.2;
    const sx = ox + s.x / s.z * f, sy = oy + s.y / s.z * f, px = ox + s.x / s.pz * f, py = oy + s.y / s.pz * f;
    const ember = [255, lerp(110, 210, s.e), lerp(20, 90, s.e)], c = [lerp(ember[0], s.c[0], mix), lerp(ember[1], s.c[1], mix), lerp(ember[2], s.c[2], mix)];
    const a = clamp((1 - s.z) * 1.4) * (.5 + p * .5);
    cx.strokeStyle = `rgba(${c[0] | 0},${c[1] | 0},${c[2] | 0},${a})`;
    cx.lineWidth = Math.max(.6, (1 - s.z) * (2.4 + p * 3));
    cx.beginPath(); cx.moveTo(px, py); cx.lineTo(sx + (sx === px ? .1 : 0), sy); cx.stroke();
  }
}
function paintWarp() {
  const st = pin.style;
  const grow = Math.pow(sstep(.08, .9, p), 2.6);
  st.setProperty('--ps', (1 + grow * 16).toFixed(3));
  st.setProperty('--pr', (p * 540).toFixed(1) + 'deg');
  st.setProperty('--swirl', (.35 + sstep(.05, .4, p) * .65).toFixed(3));
  st.setProperty('--eye', (1 - sstep(.12, .45, p)).toFixed(3));
  st.setProperty('--eyeb', (1 + sstep(.05, .3, p) * 1.5).toFixed(3));
  st.setProperty('--glow', (.5 * (1 - sstep(.3, .6, p))).toFixed(3));
  st.setProperty('--neon', (sstep(.3, .6, p) * .7).toFixed(3));
  st.setProperty('--dside', (1 - sstep(.02, .2, p)).toFixed(3));
  st.setProperty('--ent', (sstep(.42, .66, p) * (1 - sstep(.84, .93, p))).toFixed(3));
  st.setProperty('--flash', (sstep(.84, .94, p) * (1 - sstep(.96, 1, p)) + (p >= .999 ? 0 : 0)).toFixed(3));
  /* the world shakes as the portal swallows the screen */
  const sh = sstep(.6, .85, p) * (1 - sstep(.88, .95, p)) * (REDUCE ? 0 : 9);
  st.transform = sh ? `translate(${(Math.random() - .5) * sh}px,${(Math.random() - .5) * sh}px)` : '';
  $('#awGo').tabIndex = p > .2 ? -1 : 0;
}
function setArrived(on) {
  if (on === arrived) return; arrived = on;
  root.classList.toggle('aw-arrived', on);
  if (on) { if (S.on) S.boom(); startSpace(); }
}
const world = document.getElementById('awWorld');
function frame(now) {
  requestAnimationFrame(frame);
  const dt = Math.min((now - last) / 16.67, 3); last = now;
  p = progress();
  const r = warp.getBoundingClientRect(), visible = r.bottom > 0 && r.top < innerHeight;
  if (visible) { drawTunnel(dt); if (p !== shown) { paintWarp(); shown = p; } }
  setArrived(p > .9);
  if (arrived && !hyped && world.getBoundingClientRect().top < innerHeight * .55) hype();
}
if (REDUCE) { setArrived(true); setTimeout(hype); }
else requestAnimationFrame(frame);

/* "Open the portal": plays the whole crossing for the visitor */
let auto = null;
$('#awGo').addEventListener('click', () => {
  S.start();
  const from = scrollY, to = scrollY + world.getBoundingClientRect().top - (document.querySelector('.header-section')?.offsetHeight || 0), dur = REDUCE ? 1 : 4200, t0 = performance.now();
  if (S.on) S.riser(dur / 1000 * .92);
  cancelAnimationFrame(auto);
  const step = now => {
    const k = clamp((now - t0) / dur), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
    scrollTo({ top: from + (to - from) * e, behavior: 'instant' });
    if (k < 1) auto = requestAnimationFrame(step);
  };
  auto = requestAnimationFrame(step);
  const stop = () => { cancelAnimationFrame(auto); removeEventListener('wheel', stop); removeEventListener('touchstart', stop); };
  addEventListener('wheel', stop, { passive: true, once: true }); addEventListener('touchstart', stop, { passive: true, once: true });
});

/* =====================================================================
   THE FAR SIDE: slime drips (drawn per divider so no two match)
   ===================================================================== */
$$('.aw-drip').forEach((el, n) => {
  const fills = { green: 'var(--aw-slime)', orange: '#f0550a' }, Wd = 1000, Hd = 100; let x = 0, d = `M0 -12 L${Wd} -12 L${Wd} 14 `;
  let seed = 7 + n * 13; const rnd = () => (seed = (seed * 9301 + 49297) % 233280) / 233280; const pts = [];
  while (x < Wd) { const w = 26 + rnd() * 34, gap = 22 + rnd() * 60, len = 22 + rnd() * 66; pts.push([x, w, len]); x += w + gap; }
  for (let i = pts.length - 1; i >= 0; i--) { const [px, w, len] = pts[i], r = w / 2; d += `L${px + w + 12} 14 Q${px + w} 14 ${px + w} 26 L${px + w} ${len} A${r} ${r} 0 0 1 ${px} ${len} L${px} 26 Q${px} 14 ${px - 12} 14 `; }
  d += 'L0 14 Z';
  el.innerHTML = `<svg viewBox="0 0 ${Wd} ${Hd}" preserveAspectRatio="none" aria-hidden="true" style="overflow:hidden${el.classList.contains('aw-flip') ? ';transform:scaleY(-1)' : ''}"><path d="${d}" fill="${fills[el.dataset.color] || fills.green}"/></svg>`;
});

/* =====================================================================
   HYPE: the slam-in on arrival, then things that never sit still
   ===================================================================== */
const G = window.gsap;
if (G && !REDUCE) G.set(['.aw-w', '.aw-stage', '.aw-sticker', '.aw-hero .aw-btn', '.aw-hero .aw-pointer', '.aw-fine'], { opacity: 0 });
let hyped = false;
function hype() {
  if (hyped || !G || REDUCE) { $$('.aw-w, .aw-stage, .aw-sticker, .aw-hero .aw-btn, .aw-hero .aw-pointer, .aw-fine').forEach(e => { e.style.opacity = 1; }); return; }
  hyped = true;
  if (window.ScrollTrigger) G.registerPlugin(window.ScrollTrigger);
  const tl = G.timeline({ defaults: { ease: 'back.out(2.2)' }, delay: .15 });
  tl.fromTo('.aw-w', { scale: 4, opacity: 0, rotation: () => G.utils.random(-25, 25), y: -60 }, { scale: 1, opacity: 1, rotation: 0, y: 0, duration: .42, stagger: .09, ease: 'back.out(1.6)' }, 0)
    .to('.aw-world', { keyframes: [{ x: -9, y: 5 }, { x: 8, y: -6 }, { x: -5, y: 3 }, { x: 0, y: 0 }], duration: .3, ease: 'none', clearProps: 'transform' }, .6)
    .fromTo('.aw-stage', { y: 240, scale: .3, rotation: -14, opacity: 0 }, { y: 0, scale: 1, rotation: 0, opacity: 1, duration: .8 }, .45)
    .fromTo('.aw-sticker', { scale: 0, rotation: 200, opacity: 0 }, { scale: 1, rotation: 14, opacity: 1, duration: .6 }, .95)
    .fromTo('.aw-hero .aw-btn', { scale: 0, rotation: -8, opacity: 0 }, { scale: 1, rotation: 0, opacity: 1, duration: .55 }, 1.05)
    .fromTo('.aw-hero .aw-pointer', { y: 140, opacity: 0 }, { y: 0, opacity: 1, duration: .5 }, 1.25)
    .fromTo('.aw-hero .aw-bubble', { scale: 0 }, { scale: 1, duration: .4 }, 1.6)
    .to('.aw-fine', { opacity: .92, duration: .4 }, 1.6);
  tl.eventCallback('onComplete', () => {
    G.to('.aw-sticker', { rotation: '+=10', duration: .9, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    G.to('.aw-btn-big', { scale: 1.045, duration: .55, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    G.to('.aw-bubble:not(.aw-bubble-big)', { scale: 1.1, duration: .45, ease: 'sine.inOut', yoyo: true, repeat: -1, stagger: .15 });
  });
  G.to('.aw-tilt', { y: -14, duration: 2.1, ease: 'sine.inOut', yoyo: true, repeat: -1 });
  G.to('.aw-kid-head, .aw-kid-body', { y: -7, rotation: 2.5, duration: .7, ease: 'sine.inOut', yoyo: true, repeat: -1, stagger: .2, transformOrigin: '50% 100%' });
  const mm = G.matchMedia();
  mm.add('(min-width: 720px)', () => { G.to('.aw-pointer-left .aw-glove', { x: 18, duration: .32, ease: 'power2.in', yoyo: true, repeat: -1 }); G.to('.aw-pointer-right .aw-glove', { x: -18, duration: .32, ease: 'power2.in', yoyo: true, repeat: -1 }); });
  mm.add('(max-width: 719px)', () => { G.to('.aw-cta-row .aw-glove', { y: 14, duration: .32, ease: 'power2.in', yoyo: true, repeat: -1 }); });

  /* 3D tilt on the hero art */
  const stage = $('.aw-stage'), img = $('.aw-hero-img');
  if (stage && img) {
    const rx = G.quickTo(img, 'rotationX', { duration: .4, ease: 'power3' }), ry = G.quickTo(img, 'rotationY', { duration: .4, ease: 'power3' });
    stage.addEventListener('pointermove', e => { const b = stage.getBoundingClientRect(); ry(((e.clientX - b.left) / b.width - .5) * 22); rx(-((e.clientY - b.top) / b.height - .5) * 22); });
    stage.addEventListener('pointerleave', () => { rx(0); ry(0); });
  }

  /* the cartoon saucer buzzes across the page every few seconds */
  const fly = $('#awFlyby'); let dir = 1;
  (function flyby() {
    const w = innerWidth, fw = fly.getBoundingClientRect().width || 200;
    G.set(fly, { top: G.utils.random(12, 62) + 'vh', rotation: dir * 10 });
    G.fromTo(fly, { x: dir > 0 ? -fw * 1.3 : w + fw * .3 }, { x: dir > 0 ? w + fw * .3 : -fw * 1.3, duration: G.utils.random(2.2, 3.4), ease: 'power1.inOut', delay: G.utils.random(2, 6), onComplete: () => { dir *= -1; flyby(); } });
    G.fromTo(fly, { y: -18 }, { y: 18, duration: .5, ease: 'sine.inOut', yoyo: true, repeat: 15 });
  })();

  if (!window.ScrollTrigger) return;
  const st = (trigger, start = 'top 82%') => ({ trigger, start, once: true });
  $$('.aw-drip:not(.aw-flip) path').forEach(pth => G.from(pth, { scaleY: .15, duration: 1.4, ease: 'elastic.out(1,0.45)', scrollTrigger: st(pth.closest('.aw-drip'), 'top 95%') }));
  $$('.aw-pop').forEach(h => G.from(h, { scale: .2, rotation: -18, opacity: 0, duration: .6, ease: 'back.out(2.4)', scrollTrigger: st(h) }));
  if ($('.aw-pows')) G.from('.aw-pows li', { scale: 0, rotation: () => G.utils.random(-30, 30), duration: .5, stagger: .12, ease: 'back.out(2.6)', scrollTrigger: st('.aw-pows') });
  if ($('.aw-peek')) G.from('.aw-peek', { y: 200, duration: .6, ease: 'back.out(1.7)', scrollTrigger: st('.aw-peek', 'top 98%') });
  if ($('.aw-shelf')) G.from('.aw-book', { y: 180, x: i => (i % 2 ? 120 : -120), rotation: i => (i % 2 ? 40 : -40), scale: .4, opacity: 0, duration: .7, stagger: .14, ease: 'back.out(1.8)', scrollTrigger: st('.aw-shelf') });
  if ($('.aw-rv-badge')) G.from('.aw-rv-badge', { scale: 0, rotation: 200, duration: .6, ease: 'back.out(2)', scrollTrigger: st('.aw-rv-head') });
  if ($('.aw-rv-feature')) G.from('.aw-rv-feature', { y: 120, rotation: i => (i ? 8 : -8), opacity: 0, duration: .7, stagger: .15, ease: 'back.out(1.6)', scrollTrigger: st('.aw-rv-features') });
  if ($('.aw-rv-row')) G.from('.aw-rv-row', { x: i => (i ? 400 : -400), opacity: 0, duration: .8, stagger: .15, ease: 'back.out(1.4)', scrollTrigger: st('.aw-rv-rows', 'top 90%') });
  G.from('.aw-card', { y: 160, rotation: 6, opacity: 0, duration: .7, ease: 'back.out(1.5)', scrollTrigger: st('.aw-card') });
  if ($('.aw-price')) G.from('.aw-price', { scale: 5, opacity: 0, duration: .45, ease: 'power4.in', scrollTrigger: st('.aw-price', 'top 80%') });
  G.from('.aw-cta-offer .aw-pointer-left', { x: -220, opacity: 0, duration: .6, ease: 'back.out(1.6)', scrollTrigger: st('.aw-cta-offer', 'top 90%') });
  G.from('.aw-cta-offer .aw-pointer-right', { x: 220, opacity: 0, duration: .6, ease: 'back.out(1.6)', scrollTrigger: st('.aw-cta-offer', 'top 90%') });
  if ($('.aw-strip')) G.from('.aw-strip li', { y: 60, opacity: 0, rotation: () => G.utils.random(-12, 12), duration: .5, stagger: .1, ease: 'back.out(2)', scrollTrigger: st('.aw-strip', 'top 92%') });
  ScrollTrigger.refresh();
}

/* pause / play the drifting review rows */
const rvRows = $('#awRvRows'), rvPause = $('#awRvPause');
if (rvRows && rvPause) rvPause.addEventListener('click', () => {
  const paused = rvRows.classList.toggle('paused');
  rvPause.setAttribute('aria-pressed', String(paused)); rvPause.textContent = paused ? '▶ Play reviews' : '❚❚ Pause reviews';
});

/* confetti stars when something is beamed into the cart */
document.addEventListener('pod:added', () => {
  if (!G || REDUCE) return;
  const cols = ['#a6ff1f', '#ff2bd6', '#3fe7ff', '#ffe01f', '#ff6a00'];
  for (let i = 0; i < 46; i++) {
    const c = document.createElement('span');
    c.textContent = i % 3 ? '★' : '✦';
    c.style.cssText = `position:fixed;left:${50 + (Math.random() - .5) * 30}vw;top:-40px;z-index:96;pointer-events:none;font:400 ${18 + Math.random() * 26}px/1 Bangers,Impact,sans-serif;color:${cols[i % cols.length]};-webkit-text-stroke:2px #12052b;paint-order:stroke fill`;
    document.body.appendChild(c);
    G.to(c, { y: innerHeight + 80, x: (Math.random() - .5) * 360, rotation: Math.random() * 900, duration: 2 + Math.random() * 2.2, delay: Math.random() * .6, ease: 'power1.in', onComplete: () => c.remove() });
  }
});

/* =====================================================================
   SPACE: three.js flying saucers, asteroids and stars on the far side
   ===================================================================== */
let spaceOn = false;
function startSpace() {
  if (spaceOn || REDUCE) return; spaceOn = true;
  if (window.THREE) return initSpace();
  const s = document.createElement('script'); s.src = window.__awThree; s.onload = initSpace; document.head.appendChild(s);
}
function initSpace() {
  const THREE = window.THREE, canvas = $('#awSpace'); if (!THREE || !canvas) return;
  let renderer; try { renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true, powerPreference: 'high-performance' }); } catch (e) { return; }
  const small = innerWidth < 720; renderer.setPixelRatio(Math.min(devicePixelRatio || 1, small ? 1.5 : 2));
  const scene = new THREE.Scene(); scene.fog = new THREE.FogExp2(0x1b0647, 0.011);
  const camera = new THREE.PerspectiveCamera(58, 1, .1, 500); camera.position.set(0, 0, 30);
  scene.add(new THREE.AmbientLight(0x8866ff, .95));
  const key = new THREE.DirectionalLight(0xffffff, 1.1); key.position.set(6, 12, 14); scene.add(key);
  const rim = new THREE.PointLight(0xa6ff1f, 2.2, 90); rim.position.set(-14, -10, 12); scene.add(rim);
  const warm = new THREE.PointLight(0xff6a00, 1.6, 90); warm.position.set(16, 8, 6); scene.add(warm);

  const count = small ? 1400 : 2800, pos = new Float32Array(count * 3), col = new Float32Array(count * 3);
  const pal = [[1, 1, 1], [1, .45, .9], [.45, .95, 1], [.75, 1, .3], [1, .9, .3]];
  for (let i = 0; i < count; i++) {
    const r = 60 + Math.random() * 160, th = Math.random() * Math.PI * 2, ph = Math.acos(2 * Math.random() - 1);
    pos[i * 3] = r * Math.sin(ph) * Math.cos(th); pos[i * 3 + 1] = r * Math.sin(ph) * Math.sin(th); pos[i * 3 + 2] = r * Math.cos(ph) - 40;
    const c = pal[(Math.random() * pal.length) | 0]; col[i * 3] = c[0]; col[i * 3 + 1] = c[1]; col[i * 3 + 2] = c[2];
  }
  const sg = new THREE.BufferGeometry(); sg.setAttribute('position', new THREE.BufferAttribute(pos, 3)); sg.setAttribute('color', new THREE.BufferAttribute(col, 3));
  const starsP = new THREE.Points(sg, new THREE.PointsMaterial({ size: .9, vertexColors: true, transparent: true, opacity: .95, depthWrite: false })); scene.add(starsP);

  const hullMat = new THREE.MeshStandardMaterial({ color: 0x5a4de0, metalness: .85, roughness: .28 });
  const bellyMat = new THREE.MeshStandardMaterial({ color: 0x241a66, metalness: .9, roughness: .35 });
  const domeMat = new THREE.MeshStandardMaterial({ color: 0x7fe9ff, emissive: 0x1f9dff, emissiveIntensity: .7, transparent: true, opacity: .88, metalness: .2, roughness: .1 });
  const rimMat = new THREE.MeshBasicMaterial({ color: 0xa6ff1f });
  const beamMat = new THREE.MeshBasicMaterial({ color: 0xa6ff1f, transparent: true, opacity: .2, blending: THREE.AdditiveBlending, side: THREE.DoubleSide, depthWrite: false });
  const bulbGeo = new THREE.SphereGeometry(.13, 10, 10), bulbA = new THREE.MeshBasicMaterial({ color: 0xa6ff1f }), bulbB = new THREE.MeshBasicMaterial({ color: 0xff2bd6 });
  const hullGeo = new THREE.SphereGeometry(2, 40, 18), domeGeo = new THREE.SphereGeometry(.95, 28, 14, 0, Math.PI * 2, 0, Math.PI / 2);
  const rimGeo = new THREE.TorusGeometry(2, .09, 8, 64), glowGeo = new THREE.CircleGeometry(.85, 28), beamGeo = new THREE.CylinderGeometry(.7, 3.2, 9, 36, 1, true);
  function saucer(withBeam) {
    const g = new THREE.Group();
    const top = new THREE.Mesh(hullGeo, hullMat); top.scale.set(1, .2, 1); top.position.y = .06; g.add(top);
    const belly = new THREE.Mesh(hullGeo, bellyMat); belly.scale.set(.82, .3, .82); belly.position.y = -.12; g.add(belly);
    const dome = new THREE.Mesh(domeGeo, domeMat); dome.position.y = .26; g.add(dome);
    const ring = new THREE.Mesh(rimGeo, rimMat); ring.rotation.x = Math.PI / 2; g.add(ring);
    const glow = new THREE.Mesh(glowGeo, rimMat); glow.rotation.x = Math.PI / 2; glow.position.y = -.71; g.add(glow);
    const bulbs = []; for (let i = 0; i < 12; i++) { const b = new THREE.Mesh(bulbGeo, i % 2 ? bulbA : bulbB), a = i / 12 * Math.PI * 2; b.position.set(Math.cos(a) * 1.5, -.2, Math.sin(a) * 1.5); g.add(b); bulbs.push(b); }
    let beam = null; if (withBeam) { beam = new THREE.Mesh(beamGeo, beamMat.clone()); beam.position.y = -5.1; g.add(beam); }
    g.userData = { bulbs, beam }; return g;
  }
  const fleet = [[0, 9, -6, 15, 2.2, 5, .34, 0, 1.9, true], [-13, 3, -14, 7, 3.5, 6, .52, 1.7, 1.15, true], [14, 5, -16, 8, 3, 7, .46, 3.1, 1.05, true],
    [-8, -14, -8, 13, 3, 5, .4, 4.4, 1.35, false], [11, -24, -10, 12, 4, 6, .48, 2.2, 1.25, true], [-3, -36, -6, 16, 3, 6, .38, 5.3, 1.6, true], [8, -48, -12, 12, 4, 6, .5, .9, 1.2, false]]
    .slice(0, small ? 5 : 7).map(s => { const m = saucer(s[9]); m.scale.setScalar(s[8]); scene.add(m); return { m, s, prevX: 0 }; });
  const zip = saucer(false); zip.scale.setScalar(.9); scene.add(zip); let zipT = 2, zipDir = 1, zipY = 6;
  const rockMat = new THREE.MeshStandardMaterial({ color: 0x3a2a66, roughness: .95, metalness: .05, flatShading: true }), rocks = [];
  for (let i = 0; i < (small ? 10 : 18); i++) {
    const geo = new THREE.IcosahedronGeometry(.6 + Math.random() * 1.3, 0), pp = geo.attributes.position;
    for (let v = 0; v < pp.count; v++) pp.setXYZ(v, pp.getX(v) * (.75 + Math.random() * .5), pp.getY(v) * (.75 + Math.random() * .5), pp.getZ(v) * (.75 + Math.random() * .5));
    geo.computeVertexNormals(); const r = new THREE.Mesh(geo, rockMat), side = Math.random() < .5 ? -1 : 1;
    r.position.set(side * (13 + Math.random() * 16), 14 - Math.random() * 75, -6 - Math.random() * 22); r.userData = { rx: (Math.random() - .5) * .6, ry: (Math.random() - .5) * .6, bob: Math.random() * 6 };
    scene.add(r); rocks.push(r);
  }
  let scrollP = 0, tx = 0, ty = 0, camY = 0;
  function resize() { const w = innerWidth, h = innerHeight; renderer.setSize(w, h, false); camera.aspect = w / h; camera.fov = w < h ? 74 : 58; camera.updateProjectionMatrix(); }
  function onScroll() { const r = world.getBoundingClientRect(), span = r.height - innerHeight; scrollP = span > 0 ? clamp(-r.top / span) : 0; }
  addEventListener('resize', resize); addEventListener('scroll', onScroll, { passive: true });
  addEventListener('pointermove', e => { tx = (e.clientX / innerWidth - .5) * 2; ty = (e.clientY / innerHeight - .5) * 2; }, { passive: true });
  resize(); onScroll();
  const clock = new THREE.Clock();
  (function tick() {
    requestAnimationFrame(tick);
    if (!arrived || document.hidden) { clock.getDelta(); return; }   /* sleep while we are still in the dragon world */
    const dt = Math.min(clock.getDelta(), .05), t = clock.elapsedTime;
    camY += ((-scrollP * 46) - camY) * .08;
    camera.position.x += (tx * 2.2 - camera.position.x) * .05; camera.position.y += ((camY - ty * 1.2) - camera.position.y) * .08;
    camera.lookAt(camera.position.x * .4, camY, 0); starsP.position.y = camY * .85; starsP.rotation.z = t * .012; rim.position.y = camY - 10; warm.position.y = camY + 8;
    for (const f of fleet) {
      const [fx, fy, fz, rx, ry, rz, sp, ph] = f.s, a = t * sp + ph, x = fx + Math.sin(a) * rx, y = fy + Math.sin(a * 2.1) * ry + Math.sin(t * 2.4 + ph) * .25, z = fz + Math.cos(a) * rz;
      const vx = x - f.prevX; f.prevX = x; f.m.position.set(x, y, z);
      const bank = clamp(-(vx / Math.max(dt, .001)) * .05, -.5, .5); f.m.rotation.z += (bank - f.m.rotation.z) * .1;
      f.m.rotation.x = .22 + Math.sin(t * 1.3 + ph) * .08; f.m.rotation.y = t * 1.6 + ph;
      const { bulbs, beam } = f.m.userData, on = Math.floor(t * 6 + ph) % 2;
      for (let i = 0; i < bulbs.length; i++) bulbs[i].visible = (i + on) % 2 === 0 || i % 3 === 0;
      if (beam) { beam.material.opacity = .14 + Math.sin(t * 5 + ph) * .06; beam.rotation.y = -f.m.rotation.y; }
    }
    zipT -= dt;
    if (zipT <= 0 && !zip.userData.live) { zip.userData.live = true; zipDir = Math.random() < .5 ? -1 : 1; zipY = camY + (Math.random() - .5) * 16; zip.position.set(-zipDir * 44, zipY, 4 + Math.random() * 8); }
    if (zip.userData.live) { zip.position.x += zipDir * 62 * dt; zip.position.y = zipY + Math.sin(zip.position.x * .25) * 1.4; zip.rotation.z = -zipDir * .45; zip.rotation.y = t * 9; if (Math.abs(zip.position.x) > 46) { zip.userData.live = false; zipT = 3.5 + Math.random() * 4; } }
    else zip.position.x = 999;
    for (const r of rocks) { r.rotation.x += r.userData.rx * dt; r.rotation.y += r.userData.ry * dt; r.position.y += Math.sin(t * .6 + r.userData.bob) * .004; }
    renderer.render(scene, camera);
  })();
}
})();
